import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function IntroAnimation() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: "easeInOut" } }}
          className="fixed inset-0 z-[100] bg-[#fdf3f0] grid place-items-center"
          data-testid="intro-animation"
        >
          <div className="relative flex flex-col items-center">
            <motion.div
              initial={{ scale: 0.4, opacity: 0, rotate: -20 }}
              animate={{ scale: 1, opacity: 1, rotate: 0 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-[#993311] text-stone-50 grid place-items-center font-serif text-4xl md:text-5xl shadow-xl shadow-[#993311]/25"
            >
              H
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.5 }}
              className="mt-5 font-serif text-2xl md:text-3xl text-stone-900 tracking-tight"
            >
              Halli Chutney
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="mt-1 font-hand text-lg text-[#993311]"
            >
              taste of the village
            </motion.div>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.4, delay: 0.6, ease: "easeInOut" }}
              className="mt-6 h-[2px] w-40 bg-[#993311] origin-left"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
